import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnChanges,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

export interface RegionData {
  states?: string[];
  counties?: string[];
  cities?: string[];
  zip_codes?: string[];
}

@Component({
  selector: 'app-region-details',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './region-details.component.html',
  styleUrl: './region-details.component.scss',
})
export class RegionDetailsComponent implements OnChanges {
  @Input() isOpen = false;
  @Input() regions: RegionData = {};
  @Input() defaultTab = 'states';

  @Output() closed = new EventEmitter<void>();

  searchQuery = '';
  activeTab = 'states';

  ngOnChanges() {
    if (this.isOpen) {
      this.searchQuery = '';
      this.activeTab = this.defaultTab;
    }
  }

  closeModal() {
    this.closed.emit();
  }

  getTabs() {
    const tabs = [];
    if (this.regions?.states?.length)
      tabs.push({
        id: 'states',
        label: 'States',
        count: this.regions.states.length,
      });
    if (this.regions?.counties?.length)
      tabs.push({
        id: 'counties',
        label: 'Counties',
        count: this.regions.counties.length,
      });
    if (this.regions?.cities?.length)
      tabs.push({
        id: 'cities',
        label: 'Cities',
        count: this.regions.cities.length,
      });
    if (this.regions?.zip_codes?.length)
      tabs.push({
        id: 'zip_codes',
        label: 'Zip Codes',
        count: this.regions.zip_codes.length,
      });
    return tabs;
  }

  setActiveTab(tabId: string) {
    this.activeTab = tabId;
    this.searchQuery = '';
  }

  getFilteredItems(): string[] {
    let items: string[] = [];
    switch (this.activeTab) {
      case 'states':
        items = this.regions?.states || [];
        break;
      case 'counties':
        items = this.regions?.counties || [];
        break;
      case 'cities':
        items = this.regions?.cities || [];
        break;
      case 'zip_codes':
        items = this.regions?.zip_codes || [];
        break;
    }

    if (this.searchQuery.trim()) {
      const q = this.searchQuery.toLowerCase();
      items = items.filter((i) => i.toLowerCase().includes(q));
    }

    return items;
  }

  shouldShowSearch(): boolean {
    return this.getActiveTabCount() > 5;
  }

  private getActiveTabCount(): number {
    switch (this.activeTab) {
      case 'states':
        return this.regions?.states?.length ?? 0;
      case 'counties':
        return this.regions?.counties?.length ?? 0;
      case 'cities':
        return this.regions?.cities?.length ?? 0;
      case 'zip_codes':
        return this.regions?.zip_codes?.length ?? 0;
      default:
        return 0;
    }
  }
}
